import { setHref } from '../../utils/browserNav';

const SessionExpiredModal = () => (
  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby="session-expired-title"
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
  >
    <div className="w-full max-w-sm bg-white rounded-2xl border border-gray-200 p-6 text-center">
      <h2
        id="session-expired-title"
        className="text-xl font-bold text-gray-900 mb-2"
      >
        Sitzung abgelaufen
      </h2>
      <p className="text-sm text-gray-600 mb-6">
        Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.
      </p>
      <button
        onClick={() => setHref('/login')}
        className="w-full bg-emerald-600 text-white text-sm py-2 rounded-lg hover:bg-emerald-700 transition-colors"
      >
        Erneut anmelden
      </button>
    </div>
  </div>
);

export default SessionExpiredModal;
